var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_725_3926",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V24H0V8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V24H0V8Z",
    fill: "#6172F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1 8C-1 3.02944 3.02944 -1 8 -1H48C52.9706 -1 57 3.02944 57 8H55C55 4.13401 51.866 1 48 1H8C4.13401 1 1 4.13401 1 8H-1ZM56 24H0H56ZM-1 24V8C-1 3.02944 3.02944 -1 8 -1V1C4.13401 1 1 4.13401 1 8V24H-1ZM48 -1C52.9706 -1 57 3.02944 57 8V24H55V8C55 4.13401 51.866 1 48 1V-1Z",
    fill: "#1F235B",
    mask: "url(#path-1-inside-1_725_3926)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8C20.4477 8 20 8.44772 20 9C20 9.55228 20.4477 10 21 10V8ZM35 10C35.5523 10 36 9.55228 36 9C36 8.44772 35.5523 8 35 8V10ZM21 14C20.4477 14 20 14.4477 20 15C20 15.5523 20.4477 16 21 16V14ZM35 16C35.5523 16 36 15.5523 36 15C36 14.4477 35.5523 14 35 14V16ZM21 10H35V8H21V10ZM21 16H35V14H21V16Z",
    fill: "#1F235B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.3317a913e7168432ebdc35e6887fb9c7.svg";
export { ForwardRef as ReactComponent };